import { StateType } from 'data/types'
import { createSelector } from 'reselect'

const getState = (state: StateType) => state.account

export const getBalances = createSelector(getState, (balances) => balances.data ?? {})

export const getCurrencyBalance = (state: StateType, currency) => getBalances(state)[currency]

export const isFetching = createSelector(getState, (st) => st.fetching)
